import { AccessToken, UserProfile } from '@models';

export interface AuthState {
  token: AccessToken | null;
  loading: boolean;
  profile: UserProfile | null;
  error: boolean;
}

export const AUTH_STATE_SLICE = 'auth';
